$(document).on("focus", ".form-control", (ev) => {
  $(ev.currentTarget).parent(".input-group").addClass("focused")
})

$(document).on("blur", ".form-control", (ev) => {
  $(ev.currentTarget).parent(".input-group").removeClass("focused")
})
